var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deal_process"},[_c('div',{staticClass:"content_w site_content",style:({background:("url('" + _vm.tradeFlowPic + "') 0 center / contain no-repeat")})})])}
var staticRenderFns = []

export { render, staticRenderFns }